import { Recorder } from './components/VoiceRecorder/Recorder';
import logo from "./assets/youware-bg.png";
import { motion } from 'framer-motion';

function App() {
  return (
    <main 
      className="min-h-screen flex flex-col items-center justify-center relative bg-[#F5F5F0] overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 opacity-40 bg-cover bg-center bg-no-repeat grayscale-[20%]"
        style={{ 
          backgroundImage: `url(${logo})`,
        }}
      />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#F5F5F0]/80 via-[#F5F5F0]/50 to-[#F5F5F0]/90 pointer-events-none" />

      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="w-full max-w-2xl z-10 px-4"
      >
        <div className="text-center mb-10">
          <motion.h1 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-3 tracking-tight"
          >
            Audio Feedback Recorder
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            className="text-lg text-gray-600 font-light"
          >
            Record voice comments anywhere.
          </motion.p>
        </div>

        <Recorder />
      </motion.div>
    </main>
  );
}

export default App;
